/* IFUNGI-LOCALIZE-CONTENT-LINKS-V1 (2026-10-04, Claude — technical audit fix #3)
 *
 * Blog posts and pages written in the Shopify editor link to "/products/…", "/pages/…"
 * and so on without a market prefix. On the French storefront (/fr-ca/) such a link
 * leaves the market: Shopify redirects the bare path to the default English store,
 * so a French reader lands on an English page (or in the US store from outside Canada).
 * The same links also cost English readers a redirect hop.
 *
 * This script runs once per page, after the DOM is parsed, and prefixes those links
 * with the storefront's own market root (window.Shopify.routes.root, e.g. "/fr-ca/").
 * Links that already carry a market prefix are kept, except that a different market's
 * prefix is swapped for this one (a French page should not send readers to /en-ca/).
 * Left alone: links to other hosts, anchors (#…), mailto/tel, and everything outside
 * <main>. Absolute links to ifungi.com / www.ifungi.com are treated like relative ones.
 *
 * Content-only fix; the section CTAs are handled server-side by snippets/ifungi-localized-url.liquid.
 * To revert: delete this file and its <script> line in layout/theme.liquid.
 */
(function () {
  function localize() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root === '/' ) return;
    var prefix = root.replace(/\/$/, '');              /* "/fr-ca" */
    var main = document.getElementById('main') || document.body;
    var paths = /^\/(products|pages|collections|blogs|policies)(\/|$|\?|#)/;
    var ownHost = /^https?:\/\/(www\.)?ifungi\.com(\/|$)/i;
    var known = /^\/(en-ca|fr-ca|en-us)(\/|$)/i;
    var links = main.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href');
      if (!href) continue;
      var path = href;
      if (ownHost.test(href)) path = href.replace(ownHost, '/');
      if (path.charAt(0) !== '/' || path.charAt(1) === '/') continue; /* not a site path, or protocol-relative */
      if (known.test(path)) {
        /* already carries a market prefix: keep it if it is this market's, otherwise swap it
           (a French page linking to /en-ca/... should stay in French) */
        var swapped = path.replace(known, prefix + '$2');
        if (swapped !== href) a.setAttribute('href', swapped);
        continue;
      }
      if (!paths.test(path)) continue;
      a.setAttribute('href', prefix + path);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', localize);
  else localize();
})();
